import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { ApiService } from "src/app/core/services/api-service";
import { EvaluatorService } from "src/app/core/services/evaluator.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-evaluator-upload-labresult",
  templateUrl: "./evaluator-upload-labresult.component.html",
  styleUrls: ["./evaluator-upload-labresult.component.scss"],
})
export class EvaluatorUploadLabresultComponent implements OnInit {
  public files: File[] = [];
  isLoading: boolean = false;
  selectedValue;
  public xrayValue;
  public xrayImpression;
  public xrayImpressionOthers = new FormControl();
  public xrayRemarksOthers = new FormControl();
  public xrayRemarks;
  public xrayTypes: any = [];
  public xrayOthers: string = "";
  public stoolClassifications: any = [];
  public stoolColors: any = [];
  public stoolConsistencies: any = [];
  public stoolMicroscopy: any = [];
  public stoolExamRemarks: any = [];
  public stoolMethods: any = [];
  public selectedStoolClassification;
  public selectedStoolColors;
  public selectedStoolConsistencies;
  public selectedStoolMicroscopy;
  public selectedStoolExamRemarks;
  public selectedStoolMethods;
  public rprFindings;
  public rprRemarks = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<EvaluatorUploadLabresultComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
    private api: ApiService,
    private evaluatorService: EvaluatorService
  ) {}

  ngOnInit(): void {

    this.selectedValue = this.data.resultTypeValue;

    this.evaluatorService.getXrayTypes().subscribe((res) => {
      this.xrayTypes = res;
    });

    forkJoin({
      stoolClassification: this.evaluatorService.getStoolClassifications(),
      stoolColors: this.evaluatorService.getStoolColors(),
      stoolConsistencies: this.evaluatorService.getStoolConsistencies(),
      stoolMicroscopy: this.evaluatorService.getStoolMicroscope(),
      stoolExamRemarks: this.evaluatorService.getStoolExamRemarks(),
      stoolMethods: this.evaluatorService.getStoolMethods(),
    }).subscribe(
      ({
        stoolClassification,
        stoolColors,
        stoolConsistencies,
        stoolMicroscopy,
        stoolExamRemarks,
        stoolMethods,
      }) => {
        this.stoolClassifications = stoolClassification;
        this.stoolColors = stoolColors;
        this.stoolConsistencies = stoolConsistencies;
        this.stoolMicroscopy = stoolMicroscopy;
        this.stoolExamRemarks = stoolExamRemarks;
        this.stoolMethods = stoolMethods;
      }
    );
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  handleChso(e) {
    Swal.fire({
      title: "Are you sure?",
      showCloseButton: true,
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "green",
      denyButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;

        this.fileUpload().subscribe((res) => {
          const documentId = res.id;
          if (this.selectedValue == 1) {
            const body = {
              stoolClassificationId: this.selectedStoolClassification
                ? this.selectedStoolClassification
                : null,
              stoolColorId: this.selectedStoolColors
                ? this.selectedStoolColors
                : null,
              stoolConsistencyId: this.selectedStoolConsistencies
                ? this.selectedStoolConsistencies
                : null,
              microscopicExaminationId: this.selectedStoolMicroscopy
                ? this.selectedStoolMicroscopy
                : null,
              stoolExaminationRemarkId: this.selectedStoolExamRemarks
                ? this.selectedStoolExamRemarks
                : null,
              stoolMethodId: this.selectedStoolMethods
                ? this.selectedStoolMethods
                : null,
            };

            this.evaluatorService
              .stoolExamination(body, res.applicationId)
              .subscribe((res) => {
                const body = {
                  status: e,
                  remark: e == 2 ? "Failed" : "Passed",
                  resultType: 1,
                };
                this.evaluatorService
                  .fileReview(body, res.applicationId, documentId)
                  .subscribe((res) => {
                    this.isLoading = false;
                    this.dialogRef.close();
                  });
              });
          } else {
            this.isLoading = false;
            this.dialogRef.close();
          }
        });
      } else {
        this.isLoading = false;
        this.dialogRef.close();
      }
    });
  }

  handleSubmit() {
    Swal.fire({
      title: "Are you sure?",
      showCloseButton: true,
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "green",
      denyButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;


        this.fileUpload().subscribe((res) => {
          if (this.selectedValue == 2) {
            let remarks;

            if (this.data.remarks?.length > 0) {
              remarks = this.data.remarks[0].comment;
            } else {
              remarks =
                this.xrayRemarks == 1 ? "Normal" : this.xrayRemarksOthers.value;
            }
            const body = {
              status: this.xrayRemarks == 1 ? 1 : 0,
              remark: remarks,
              resultType: 2,
            };

            this.evaluatorService
              .fileReview(body, res.applicationId, res.id)
              .subscribe((res) => {
                this.isLoading = false;
                this.dialogRef.close();
              });
          } else if (this.selectedValue == 3) {
            let remarks;

            if (this.data.remarks?.length > 0) {
              remarks = this.data.remarks[0].comment;
            } else {
              remarks =
                this.rprFindings == 1 ? "Non-Reactive" : this.rprRemarks.value;
            }

            const body = {
              status: this.rprFindings == 1 ? 1 : 0,
              remark: remarks,
              resultType: 3,
            };

            this.evaluatorService
              .fileReview(body, res.applicationId, res.id)
              .subscribe((res) => {
                this.isLoading = false;
                this.dialogRef.close();
              });
          } else {
            this.isLoading = false;
            this.dialogRef.close();
          }
        });
      } else {
        this.isLoading = false;
        this.dialogRef.close();
      }
    });
  }

  isLabExist(id) {
    return this.data.files?.some((lab) => lab.resultTypeValue === id);
  }

  fileUpload() {
    const formData: FormData = new FormData();

    if (this.data.impressions) {
      formData.append("Impressions", this.data.impressions);
    } else if (this.selectedValue == 2) {
      formData.append(
        "Impressions",
        this.xrayImpression == 1
          ? "Essentially Normal Chest"
          : this.xrayImpressionOthers.value
      );
    }

    if (this.data.findings) {
      formData.append("Findings", this.data.findings);
    } else if (this.selectedValue == 3) {
      formData.append(
        "Findings",
        this.rprFindings == 1 ? "Non-Reactive" : "Reactive"
      );
    }

    formData.append("ApplicationId", this.data.applicationId);
    formData.append(
      "ResultType",
      this.data.resultTypeValue ? this.data.resultTypeValue : this.selectedValue
    );
    this.files.forEach((file, index) => {
      formData.append("Files", file, file.name);
    });

    const url = `/evaluator/application/${this.data.applicationId}/labresult`;

    return this.api.post(url, formData);
  }
}
